export default {
      id: "oc-res-schedpolicy-usage",
      viewBox: "0 0 1051 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-schedpolicy",
      toString: function () {
        return this.url;
      }
    }